import React from 'react';

import { useSearchParams } from 'react-router-dom';

import { AdvisorErrorPage } from '../../../../Shared/Components/AdvisorErrorPage';
import { FourOhOneKBlockedErrorPageStepProps } from '../types';

export const FourOhOneKBlockedErrorPage: React.FC<FourOhOneKBlockedErrorPageStepProps> = ({ flowState }) => {
  const { returnToPath } = flowState;
  const [searchParams] = useSearchParams();
  const assetTicker = searchParams.get('assetTicker') || '';
  return (
    <AdvisorErrorPage
      returnAddress={returnToPath}
      headerText={`Sell ${assetTicker}`}
      titleText="Direct trading is not currently supported for 401(k) accounts"
      bodyText="Alternatively, you can make adjustments to your client's 401(k) investments by managing their portfolio strategy or asset allocations."
    />
  );
};
